export const deals = {
  title: 'Ügyletek',
  new: 'Új ügylet',
  view: 'Ügylet megtekintése',
  edit: 'Ügylet szerkesztése',
  noDeals: 'Nincs ügylet',
  fields: {
    type: 'Típus',
    customer: 'Ügyfél',
    date: 'Dátum',
    followUpDate: 'Következő lépés dátuma',
    description: 'Leírás',
    outcome: 'Eredmény',
    subject: 'Tárgy',
    duration: 'Időtartam',
    status: 'Státusz',
    minutes: 'Perc',
    notSet: 'Nincs beállítva',
  },
  status: {
    completed: 'Kész',
    pending: 'Függőben',
    rejected: 'Elutasítva',
  },
  types: {
    phone: 'Telefon',
    email: 'Email',
  },
  messages: {
    notSet: 'Nincs beállítva',
    updated: 'Ügylet sikeresen frissítve',
    created: 'Ügylet sikeresen létrehozva',
    deleted: 'Ügylet sikeresen törölve',
    error: 'Hiba történt a ügylet létrehozása közben',
    confirmTitle: 'Ügylet törlése',
    deleteQuestion: 'Biztosan törölni szeretné ezt az ügyletet?',
    deleteWarning: 'Ez a művelet nem visszavonható.'
  }
}